import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

export function renderTulvariskiBlock({
  contentWidth = CONTENT_WIDTH,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) throw new Error("content is required");

  const buildings =
    rakennusData?.rakennukset_fulls || [];

  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const renderCellValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  const createCell = (
    text,
    {
      bold = false,
      color = "black",
      fillColor,
      alignment = "left"
    } = {}
  ) => ({
    text: renderCellValue(text),
    bold,
    color,
    fillColor,
    alignment,
    font: "Lato",
    fontSize: smallFontSize
  });

  const createTableLayout = () => ({
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 4,
    paddingBottom: () => 4,
    dontBreakRows: false
  });

  // Collect flood-risk results from all buildings
  const allTulva = buildings.flatMap(
    building =>
      building.aluetiedot?.tulvariski || []
  );

  // Remove duplicates
  const uniqueTulva = [];
  const seenTulva = new Set();

  allTulva.forEach(item => {
    const key = [
      item.lähde || "",
      item.nimi || "",
      item.etäisyys || ""
    ].join("|");

    if (!seenTulva.has(key)) {
      seenTulva.add(key);
      uniqueTulva.push(item);
    }
  });

  // Areas where the building actually lies inside the polygon
  const alueella = uniqueTulva.filter(
    item => item.etäisyys === "Alueella"
  );

  // Areas found nearby, but building is not inside them
  const lahella = uniqueTulva.filter(
    item => item.etäisyys !== "Alueella"
  );

  const body = [
    [
      {
        ...createCell("Tulvariskialueet", {
          bold: true,
          color: WHITE,
          fillColor: GREEN
        }),
        colSpan: 2
      },
      {}
    ]
  ];

  // ─────────────────────────────────
  // Actual flood-risk status
  // ─────────────────────────────────

  body.push([
    createCell("Sijaitsee tulvariskialueella", {
      bold: false
    }),
    createCell(
      alueella.length > 0 ? "Kyllä" : "Ei",
      {
        bold: false
      }
    )
  ]);

  // ─────────────────────────────────
  // Areas containing the building
  // ─────────────────────────────────

  alueella.forEach((item, index) => {
    body.push([
      {
        ...createCell(
          alueella.length > 1
            ? `Tulvariskialue ${index + 1}`
            : "Tulvariskialue",
          {
            bold: true,
            fillColor: LIGHT_GREY
          }
        ),
        colSpan: 2
      },
      {}
    ]);

    body.push([
      createCell("Nimi"),
      createCell(item.nimi)
    ]);

    if (item.lähde) {
      body.push([
        createCell("Tyyppi"),
        createCell(item.lähde)
      ]);
    }

    body.push([
      createCell("Sijainti"),
      createCell("Alueella")
    ]);
  });

  // ─────────────────────────────────
  // Nearby flood-risk areas
  // ─────────────────────────────────

if (lahella.length > 0) {
  lahella.forEach((item, index) => {
    body.push([
      createCell(
        index === 0
          ? "Lähistöllä olevat tulvariskialueet"
          : ""
      ),
      createCell(
        item.lähde ||
        item.nimi ||
        "Tulvariskialue"
      )
    ]);

    body.push([
      createCell("Etäisyys"),
      createCell(
        item.etäisyys || "–"
      )
    ]);
  });
}

  // Nothing found within backend search radius
  if (uniqueTulva.length === 0) {
    body.push([
      {
        ...createCell(
          "Tulvariskialueita ei havaittu 500 metrin säteellä."
        ),
        colSpan: 2
      },
      {}
    ]);
  }

  const TABLE_WIDTH =
    contentWidth * 0.92;

  content.push({
    table: {
      widths: [
        TABLE_WIDTH * 0.47,
        TABLE_WIDTH * 0.58
      ],
      body
    },

    layout: createTableLayout(),

    margin: [
      0,
      0,
      0,
      bottomMarginItemGlobal
    ]
  });
}